<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <base-card>
          <v-card-title class="d-flex justify-space-between mb-3">
            Signup
            <div>
              <v-btn
                class="ma-2"
                color="primary"
                @click="$router.push({ name: 'create-sign-up' })"
              >
                <v-icon>mdi-plus</v-icon>
                Create New
              </v-btn>
            </div>
          </v-card-title>
          <v-data-table
            item-key="id"
            class="elevation-1 data-table"
            :headers="headers"
            :items="getSignup || []"
            :disable-filtering="true"
          >
            <template v-slot:item.created_at="{ item }">
              {{ item | datetime }}
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="success"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="
                        $router.push({
                          name: 'edit-sign-up',
                          params: { id: item.id },
                        })
                      "
                    >
                      <v-icon>mdi-pencil-box-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="danger"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      icon
                      @click="openDeleteDialog(item)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </base-card>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" class="ma-0" max-width="50%">
      <v-card class="card-50-radius h-50 w-100" v-if="selectedSignup">
        <v-card-title>
          Delete this {{ selectedSignup.company_name }}?
        </v-card-title>
        <v-card-subtitle class="mt-1">
          All data connected to this signup will be permanently deleted. This is
          no longer reversable. Are you sure you want to continue?
        </v-card-subtitle>

        <v-card-actions>
          <v-btn
            block
            class="my-2 text-white"
            color="danger"
            @click="destroy()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Signup",
  },

  data() {
    return {
      selectedSignup: null,
      deleteDialog: false,
      headers: [
        {
          text: "Create Date",
          align: "start",
          sortable: false,
          value: "created_at",
        },
        { text: "Company Name", value: "company_name", sortable: true },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Paid", value: "is_paid" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  methods: {
    ...mapActions(["destroySignup"]),
    async destroy() {
      await this.destroySignup(this.selectedSignup.id);

      this.deleteDialog = false;
      this.selectedSignup = null;
    },

    openDeleteDialog(signup) {
      this.deleteDialog = true;
      this.selectedSignup = signup;
    },
  },
  computed: {
    ...mapGetters(["getSignup"]),
    getValue() {
      return (value, path, defaultValue = "") =>
        _.get(value, path, defaultValue);
    },
  },
  filters: {
    datetime(value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
};
</script>
<style lang="scss" scoped>
.event-filters {
  .filter-input {
    margin: 0 0.5rem;
  }

  ::v-deep .v-text-field__details {
    display: none;
  }
}

::v-deep .table-one {
  tbody {
    tr {
      &:hover {
        background-color: #f2f3f8 !important;
      }
    }
  }

  .multiple-signup {
    background-color: rgb(255, 221, 117, 0.4);
  }
}

.text-white {
  color: #fff;
}
</style>
